// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/static/css/App.css
// module id = 2814
// module chunks = 0